export enum RoleStatuses {
  Active = "ACTIVE",
  Inactive = "INACTIVE",
  Pending = "PENDING",
}
